import { ImageVariationModel } from "./imageVariation";
import { ImageTypeModel } from "./imageType";
import { UUID } from "../generic/uuid";
import { ImageDto } from "@vini-wine/core-dtos";

export interface ImageModel extends UUID {
  // transform
  name: string;
  mime: string;
  height: number;
  width: number;
  url: string;
  variation: ImageVariationModel;
  type: ImageTypeModel;
}

export const createImageDtoFromOfferImageModel = (
  image: ImageModel,
): ImageDto => {
  return {
    name: image.name,
    mime: image.mime,
    height: image.height,
    width: image.width,
    url: image.url,
    variation: {
      id: image.variation.id,
    },
    type: {
      id: image.type.id,
    },
    size: 0,
  };
};
